var _path, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 116,
    viewBox: "0 0 140 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9428 72.2614C67.3801 73.4216 67.4248 74.7866 68.0588 75.9101L77.0685 91.348C77.831 92.6569 77.7565 94.2899 76.8792 95.5267C76.0365 96.7851 74.5449 97.443 73.0471 97.2278L55.342 94.891C54.7243 94.8041 54.0961 94.8656 53.5021 95.0631L52.5918 95.3949C52.2932 95.557 52.0209 95.7704 51.7951 96.0277L39.7563 109.248C39.1554 109.885 38.3701 110.32 37.5061 110.486C35.3804 110.835 33.3631 109.424 32.9605 107.307L29.9264 89.6908C29.6851 88.4127 28.8385 87.3324 27.6563 86.7929L11.2419 79.4574C9.86878 78.8429 8.97739 77.4935 8.95488 75.991C8.92017 74.4968 9.71512 73.1073 11.0228 72.3834L26.8343 63.8768C28.0563 63.283 28.8899 62.1039 29.0446 60.7537L30.9037 42.9906C30.956 42.591 31.0684 42.2 31.245 41.8388L31.4616 41.4935C31.5558 41.2613 31.6845 41.0507 31.8432 40.8597L32.1604 40.5919L32.6457 40.1486L34.0598 39.6332C35.3706 39.3039 36.7579 39.6544 37.7503 40.5712L50.6766 52.8692C51.6144 53.7717 52.937 54.1535 54.2102 53.8987L71.7871 50.2358C73.2714 49.9231 74.8054 50.4675 75.762 51.6409C76.693 52.8275 76.8521 54.4438 76.1714 55.7916L67.9428 72.2614Z",
    fill: "url(#paint0_linear_1_104)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4614 63.328C44.774 63.328 38.5349 69.5685 38.5349 77.2545C38.5349 84.9433 44.774 91.181 52.4614 91.181C60.1628 91.181 66.3879 84.9433 66.3879 77.2545C66.3879 69.5685 60.1628 63.328 52.4614 63.328Z",
    fill: "#FF3D22"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.937 69.6666C107.519 70.4853 106.593 71.9522 106.459 73.5852L104.93 96.235C104.798 98.1544 103.556 99.818 101.753 100.493C99.9702 101.216 97.9333 100.844 96.5121 99.5507L79.5643 84.4773C78.9768 83.9458 78.2725 83.5628 77.5074 83.3471L76.314 83.0473C75.8845 83.0049 75.4462 83.0352 75.0254 83.1448L52.9487 88.4638C51.8626 88.7058 50.7273 88.6032 49.7004 88.1625C47.2174 87.0142 46.102 84.0935 47.1875 81.5806L56.551 60.8993C57.2081 59.3837 57.088 57.6446 56.2296 56.2351L44.2008 36.8264C43.1951 35.202 43.2196 33.1482 44.2666 31.5526C45.2949 29.957 47.1207 29.0628 49.0114 29.2336L71.6955 31.5581C73.4033 31.8046 75.1198 31.1591 76.2447 29.85L90.8571 12.5008C91.1968 12.1179 91.5936 11.7869 92.0366 11.5331L92.5104 11.3244C92.7749 11.1474 93.0603 11.0178 93.3633 10.9301L93.8875 10.8745L94.7136 10.7544L96.5676 11.2203C98.1802 11.8081 99.3889 13.1652 99.7789 14.8362L104.604 36.9761C104.947 38.5932 106.066 39.937 107.586 40.5764L128.674 49.251C130.457 49.98 131.682 51.6455 131.852 53.5608C131.985 55.4716 131 57.2842 129.324 58.216L108.937 69.6666Z",
    fill: "#FFAC95",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.428 96.2687L105.428 96.2691C105.284 98.3824 103.918 100.214 101.934 100.959C99.9744 101.751 97.7382 101.341 96.1776 99.9224C96.1769 99.9218 96.1762 99.9211 96.1755 99.9205L79.232 84.8509L79.2288 84.8481C78.7022 84.3716 78.0693 84.0261 77.3785 83.8303L76.2293 83.5415C75.8672 83.5097 75.5009 83.5376 75.1514 83.6287L75.1425 83.631L75.1425 83.6309L53.0659 88.9499L53.0575 88.9519L53.0575 88.9518C51.8697 89.2165 50.6274 89.1044 49.5032 88.622L49.4905 88.6165L49.4905 88.6164C46.7612 87.3542 45.5355 84.144 46.7285 81.3823L46.732 81.3744L46.7321 81.3744L56.0923 60.7004C56.0928 60.6992 56.0933 60.698 56.0938 60.6969C56.6843 59.3316 56.5758 57.7661 55.8035 56.4968C55.8032 56.4962 55.8029 56.4957 55.8025 56.4952L43.7758 37.0898L43.7757 37.0896C42.6684 35.301 42.6945 33.0385 43.8474 31.28C44.9764 29.5297 46.9806 28.5481 49.0564 28.7356L49.0624 28.7361L49.0623 28.7362L71.7465 31.0607C71.7533 31.0614 71.7602 31.0622 71.767 31.0632C73.3043 31.2851 74.8501 30.7045 75.8638 29.526C75.8644 29.5254 75.8649 29.5247 75.8654 29.5241L90.4747 12.1787L90.483 12.1688L90.4831 12.1689C90.8558 11.7488 91.2943 11.3822 91.7881 11.0993C91.8033 11.0905 91.819 11.0826 91.8351 11.0755L92.2704 10.8838C92.5692 10.6895 92.889 10.5469 93.2242 10.4498C93.2524 10.4416 93.2814 10.436 93.3106 10.4329L93.8252 10.3784L94.6417 10.2596C94.7063 10.2502 94.7721 10.2536 94.8355 10.2695L96.6894 10.7353C96.7061 10.7395 96.7226 10.7446 96.7388 10.7505C98.5091 11.3958 99.8372 12.8862 100.266 14.7226L100.267 14.7297L100.267 14.7298L105.093 36.8697L105.094 36.8725C105.402 38.3275 106.408 39.5382 107.778 40.1148C107.778 40.1151 107.779 40.1153 107.779 40.1155L128.863 48.7882C128.864 48.7883 128.864 48.7884 128.864 48.7885L128.864 48.7886L105.428 96.2687ZM105.428 96.2687L106.957 73.6261L105.428 96.2687Z",
    stroke: "url(#paint1_linear_1_104)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_104",
    x: 18.5349,
    y: 43.328,
    width: 67.853,
    height: 67.853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1_104"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1_104",
    x: 18.4636,
    y: -14.2456,
    width: 138.4,
    height: 140.103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_104",
    x1: 13.5803,
    y1: 66.8538,
    x2: 87.3535,
    y2: 135.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F23E2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_104",
    x1: 63.4869,
    y1: 13.2717,
    x2: 98.9457,
    y2: 95.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.b33dada70aad8da7e91c072c13610021.svg";
export { ForwardRef as ReactComponent };